<template>
    <div class="setpwd">
        <p style="font-size: 20px;color: #000">{{$t('setPayPwd')}}</p>
        <div>
            <p>{{$t('setPayPwdAgain')}}</p>
            <van-password-input
                :value="value"
                :gutter="10"
                :error-info="errorInfo"
                :focused="showKeyboard"
                @focus="showKeyboard = true"
            />
            <van-number-keyboard
                v-model="value"
                :show="showKeyboard"
                @blur="showKeyboard = false"
            />
            <van-switch v-model="isUseLogin" size="20px" style="margin-top: 20px;margin-left:14px;"/>
              <span style="position: relative; top:-4px;margin-left:2px;">{{$t('payPwdFlag')}}</span>
            <van-button size="large" round type="danger" @click="toStore" style="margin-top: 20px;">{{$t('sure')}}</van-button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { ref } from 'vue';
import {mapGetters, mapActions} from 'vuex';
import { Dialog } from 'vant';
import qs from 'qs';

export default {
  name: 'Finish',
  data(){
    return{
        accessToken: localStorage.getItem('accessToken'),
        appId: localStorage.getItem('appId'),
        showKeyboard: true,
        value: '',
        errorInfo: '',
        isUseLogin: false
    }
  },
  methods: {
    ...mapActions(['setPayPwd', 'getEmailFlag', 'changePayPwd']),
    toStore(){
      if(this.$md5(this.value.substring(0,6)) !== this.$route.query.pwd){
        this.errorInfo = this.$t('pwdDontmatch')
      } else {
        this.errorInfo = ''
        if(this.$route.query.oldPwd){
          this.changePayPwd({
            type: 2,
            accessToken: this.accessToken,
            appId: this.appId,
            newPassword: this.$md5(this.value.substring(0,6)),
            oldPassword: this.$route.query.oldPwd,
            isUseLogin: this.isUseLogin ? 1 : 0,
            uid: window.localStorage.getItem('uid') || ''
          })
        } else if(this.$route.query.eCode){
          this.changePayPwd({
            type: 1,
            accessToken: this.accessToken,
            appId: this.appId,
            newPassword: this.$md5(this.value.substring(0,6)),
            emailCode: this.$route.query.eCode,
            isUseLogin: this.isUseLogin ? 1 : 0,
            uid: window.localStorage.getItem('uid') || ''
          })
        } else {
          this.setPayPwd(qs.stringify({
            accessToken: this.accessToken,
            appId: this.appId,
            newPassword: this.$md5(this.value.substring(0,6)),
            isUseLogin: this.isUseLogin ? 1 : 0
          }))
        }
      }
    }
  },
  computed:{
    ...mapGetters(['pwdData', 'psStatus', 'emailFlag', 'efLoading', 'cPwdData', 'cpStatus']),
  },
  mounted(){
      this.getEmailFlag({
          accessToken: this.accessToken,
          appId: this.appId,
          uid: window.localStorage.getItem('uid') || ''
      })
      // this.$watch('value', val => {
      //     if(val.length > 5){
      //       if(this.$md5(val) !== this.$route.query.pwd){
      //         this.errorInfo = '两次密码不一致'
      //       } else {
      //         this.errorInfo = ''
      //         if(!this.$route.query.oldPwd){
      //           this.setPayPwd(qs.stringify({
      //             accessToken: this.accessToken,
      //             appId: this.appId,
      //             newPassword: this.$md5(val)
      //           }))
      //         } else {
      //           this.changePayPwd({
      //             type: 2,
      //             accessToken: this.accessToken,
      //             appId: this.appId,
      //             newPassword: this.$md5(val),
      //             oldPassowrd: this.$route.query.oldPwd
      //           })
      //         }
      //       }
      //     }
      // })
      this.$watch('cpStatus', val => {
        if(val == 'stated'){
          if(this.cPwdData == 'success'){
            if(this.$route.query.from == 'paylogin'){
              Dialog.confirm({
                title: this.$t('payTits'),
                message: this.$t('toReloginTits'),
                showConfirmButton: false,
                closeOnClickOverlay: false,
                cancelButtonText: this.$t('backToLogin')
              })
              .then(() => {
                window.localStorage.setItem('uid', '')
                this.$router.push({
                  path: '/login',
                  query: {
                    from: 'error'
                  }
                })
              })
              .catch(() => {
                window.localStorage.setItem('uid', '')
                this.$router.push({
                  path: '/login',
                  query: {
                    from: 'error'
                  }
                })
              });
            } else {
              if(!this.emailFlag.isEmailSet){
                Dialog.confirm({
                  title: this.$t('payTits'),
                  message: this.$t('toSetEmailTits'),
                  cancelButtonText: this.$t('backToStore'),
                  confirmButtonText: this.$t('toSetEmail')
                })
                .then(() => {
                  this.$router.push({
                    path: '/bindemail'
                  })
                })
                .catch(() => {
                  this.$router.push({
                    path: '/store'
                  })
                });
              } else {
                this.$router.push({
                  path: '/store'
                })
              }
            }
          }
        }
      })
      this.$watch('psStatus', val => {
        if(val == 'stated'){
          if(this.pwdData == 'success'){
            if(!this.emailFlag.isEmailSet){
              Dialog.confirm({
                  title: this.$t('payTits'),
                  message: this.$t('toSetEmailTits'),
                  cancelButtonText: this.$t('backToStore'),
                  confirmButtonText: this.$t('toSetEmail')
              })
              .then(() => {
                this.$router.push({
                  path: '/bindemail'
                })
              })
              .catch(() => {
                this.$router.push({
                  path: '/store'
                })
              });
            } else {
              this.$router.push({
                path: '/store'
              })
            }
          } 
        }
      })
  },
  beforeDestroy(){
  }
}
</script>

<style lang="scss">
.setpwd{
  margin: 10px;
  img{
    display: block;
    width: 20%;
    margin: 0 auto;
  }
  p{
    text-align: center;
    font-size: 10px;
    color: #9e9e9e;
    margin-top: 20px;
  }
  .van-button{
    height: 30px;
    margin: 0 auto;
    position: relative;
    display: block;
    line-height: 30px;
    text-align: center;
    width: 40%;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .login_tips{
      text-align: center;
      font-size: 14px;
      margin: 10px 0;
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-swipe-item{
    img{
      width: 100%;
    }
  }
  .van-password-input__security{
        li{
            background-color: #e9e9e9;
            border-radius: 6px;
            &.van-password-input__item--focus{
                background-color: #fff;
                border: 1px solid #e60012;
            }
        }
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-password-input__security{
      height: 45px;
  }
  .van-overlay{
    z-index: 101;
  }
}
</style>
